import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { WarningIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../lib/hooks/use-translate'
import { DiffuseTripBookingsResponse } from '../../../../lib/types/models/center/center'

type Props = {
  centers: DiffuseTripBookingsResponse['notDiffusedCenters']
  onClose: () => void
}

/** Lists the selected centers whose presta received no travel-info email, with the reason. */
export const NotDiffusedCentersModal = ({ centers, onClose }: Props) => {
  const { t } = useTranslate()

  return (
    <Modal
      isOpen={centers.length > 0}
      icon={WarningIcon}
      title={t('ol.center.trip.booking.not.diffused.title')}
      onCancel={onClose}
    >
      <div className={MODAL_BODY_CLASSNAME}>
        <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
          {centers.length > 1
            ? t('ol.center.trip.booking.not.diffused.message.multiple')
            : t('ol.center.trip.booking.not.diffused.message.single')}
        </Typography>
        <ul className="list-disc pl-5 mt-3">
          {centers.map((center) => (
            <li key={center.id}>
              <Typography variant="label" color={tailwindColors.grey.DEFAULT}>
                {center.name} : {center.reason}
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}
